module.exports = __webpack_public_path__ + "static/media/world.21119dde.png";